$(document).ready(function() {

  

/* PRODUCT ARTICLE SWITCH */
$(".show-products").click(function(e) {
  $(this).addClass("active");
  $(".show-articles").removeClass("active");
  $("section.article-data").hide();
  $("section.product-data").show();
});

$(".show-articles").click(function(e) {
  $(this).addClass("active");
  $(".show-products").removeClass("active");
  $("section.article-data").show();
  $("section.product-data").hide();
});

  
/* RECOMMENDATIONS */

(function() {
    let originalFetch = window.fetch;
    let isUpdating = false; // Prevent infinite loop

    /* PREVENTS JUDGEME....
    window.fetch = async function(url, options) {
      console.log("HERE");
        if (url.includes('/cart') && !url.includes('/cart.js')) { // Ignore cart.js fetch
            const response = await originalFetch(url, options);
            if (response.ok) {
                $(document).trigger('cart:updated');
            }
            return response;
        }
        return originalFetch(url, options);
    };
    */

    async function updateRecommendedProducts() {
        if (isUpdating) return; // Prevent multiple updates
        isUpdating = true;

        try {
            const cartResponse = await originalFetch('/cart.js'); // Use originalFetch to avoid interception
            if (!cartResponse.ok) return;

            const cartData = await cartResponse.json();
            const variantIds = cartData.items.map(item => item.variant_id);

            console.log('Cart Variant IDs:', variantIds);

            // Hide recommended products that are in the cart
            $('product-recommendations .product-item').each(function() {
                let classes = $(this).attr('class').split(' ');
                let matched = classes.find(cls => cls.startsWith('id-') && variantIds.includes(parseInt(cls.replace('id-', ''), 10)));
                
                if (matched) {
                    $(this).hide();
                } else {
                    $(this).show();
                }
            });
        } catch (error) {
            console.error('Error fetching cart data:', error);
        }

        isUpdating = false;
    }

    $(document).on('cart:updated', function() {
        console.log('Cart updated!');
        updateRecommendedProducts();
    });

    $(document).ready(function() {
        updateRecommendedProducts();
    });

})();


/* FIX BLOG LINKS */
$('a[href*="/product/"]').each(function () {
    let href = $(this).attr('href');
    let newHref = href.replace(/^https?:\/\/[^/]+\/product\/\d+\//, "/products/")
                      .replace(/-{2,}/g, "-"); // Ensures multiple dashes become a single dash
    $(this).attr('href', newHref).attr('target', '_self'); // Set target to _self
});

  

/* EXTERNAL LINKS */
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

$("#full-info-btn").click(function(e) {
  $("#full-info .open-children-toggle").click();
});


if($(".item-4-ja").length){
  $(".filter-arvostelut").show();
}

  
/* SLIDING LINKS */
$("a:not([data-kr-brand-link]):not([data-kr-brand-return])").click(function(e) {
    var aid = $(this).attr("href");

    // Check if href is an anchor on the same page (starts with '#' but is not just '#')
    if (aid && aid.startsWith("#") && aid.length > 1) {
        var target = $(aid);
        if (target.length) {
            //e.preventDefault();
            $("html, body").animate({ scrollTop: target.offset().top - 80 }, "slow");
        }
    }
});

/* MODELS FILTERING */
  $(".model-filter-box input").on("input", function () {
      let filterText = $(this).val().toLowerCase().trim();
      let $ul = $(this).parent().next("ul");
      let $items = $ul.children("li").not(".no-results"); // Exclude the no-results message

      // Filter list items
      let visibleItems = 0;
      $items.each(function () {
          let match = $(this).text().toLowerCase().includes(filterText);
          $(this).toggle(match);
          if (match) visibleItems++;
      });

      // Handle "No results found" message
      let $noResults = $ul.find(".no-results");
      if (visibleItems === 0) {
          if ($noResults.length === 0) {
              $ul.append('<li class="no-results text-gray-500 italic">Vastaavia malleja ei löytynyt.</li>');
          }
      } else {
          $noResults.remove();
      }
  });
  
/* SKUS FILTERING */
  $(".sku-filter-box input").on("input", function () {
      let filterText = $(this).val().toLowerCase().trim();
      let $ul = $(this).parent().next("ul");
      let $items = $ul.children("li").not(".no-results"); // Exclude the no-results message

      // Filter list items
      let visibleItems = 0;
      $items.each(function () {
          let match = $(this).text().toLowerCase().includes(filterText);
          $(this).toggle(match);
          if (match) visibleItems++;
      });

      // Handle "No results found" message
      let $noResults = $ul.find(".no-results");
      if (visibleItems === 0) {
          if ($noResults.length === 0) {
              $ul.append('<li class="no-results text-gray-500 italic">Vastaavia Varaosat ei löytynyt.</li>');
          }
      } else {
          $noResults.remove();
      }
  });
  
/* REVIEWS BOX */
const observer = new MutationObserver((mutations) => {
  if ($(".jm-review-item").first().length) {
    // Reviews are now loaded, execute the code
    $(".product-detail__information .jdgm-widget").append(
      "<div class='review-glance skeleton-loading'><div class='review-title'></div><div class='review-text'></div><div class='review-author jdgm-rev__author'></div><a href='#jdgm-grid-body' class='hidden customer-images'><svg xmlns='http://www.w3.org/2000/svg' width='18px' height='18px' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' class='inline-block lucide lucide-camera'><path d='M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z'></path><circle cx='12' cy='13' r='3'></circle></svg><span>Katso asiakaskuvat</span></a></div>"
    );

    $(".customer-images").on("click", function (e) {
      e.stopPropagation();
      e.preventDefault();
      const top = document.getElementById("jdgm-grid-body").getBoundingClientRect().top + window.scrollY - 50;
      window.scrollTo({ top, behavior: "smooth" });
    });

    let reviewText = $(".jm-review-item")
      .first()
      .find(".jdgm-review-content__body-content p")
      .text()
      .trim();

    if (reviewText.length > 150) {
      reviewText = reviewText.substring(0, 150) + "...";
    }

    if (reviewText != "-") {
      $(".review-title").text(reviewText);
      $(".review-author").text(
        $(".jm-review-item").first().find(".jm-reviewer-info__name").text()
      );
    } else {
      $(".review-glance").hide();
    }

    // Stop observing once we've found and processed the reviews
    observer.disconnect();
  }
});

// Start observing the document body for changes
observer.observe(document.body, {
  childList: true,
  subtree: true
});

setTimeout(() => {
  if ($(".jm-media-preview").length) {
    $(".jdgm-grid-body").attr("id", "jdgm-grid-body");
    $(".customer-images").removeClass("hidden");
  }
}, 3500);
  

  
/* CHECK FOR MOBILE */
$(function() {      
    let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

    if (isMobile) {
      console.log("MOBILE");
    }
 });


$(".close-btn").on("click", function() {
  $(".sku-wizard").fadeOut(500);
  console.log("haha");
});


 
/* COMPARE BOX */
let hideTimeout;

// Trigger on button click
$("button-compare").on("click", function() {
  

  // Show the compare box
  $("#compare-box").addClass("show");

  // Set timeout to hide the box after 4 seconds if not hovered
  hideTimeout = setTimeout(function() {
    $("#compare-box").removeClass("show");
  }, 4000);
});

// Clear timeout if box is hovered
$("#compare-box").hover(
  function() {
    clearTimeout(hideTimeout);
  },
  function() {
    // Restart the hide timeout when hover ends
    hideTimeout = setTimeout(function() {
      $("#compare-box").removeClass("show");
    }, 4000);
  }
);

/* FREE GIFT */
/*
  
document.addEventListener('DOMContentLoaded', function() {
    const targetProductId = 46067109757083; // Replace with the product ID that triggers the gift
    const giftProductId = 46059459117211;   // Replace with the gift product ID

    async function getCart() {
        const response = await fetch('/cart.js');
        return response.json();
    }

    async function addProductToCart(productId, quantity = 1) {
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: productId, quantity: quantity })
        });
    }

    async function checkAndAddGift() {
        let cart = await getCart();
        let hasTriggerProduct = cart.items.some(item => item.id === targetProductId);
        let hasGiftProduct = cart.items.some(item => item.id === giftProductId);

        if (hasTriggerProduct && !hasGiftProduct) {
            await addProductToCart(giftProductId);
            //alert('A free gift has been added to your cart!');
            $(document).trigger('cart:updated');
        }
    }

    document.body.addEventListener('click', async function(event) {
        if (event.target.matches('form[action*="/cart/add"] [type="submit"]')) {
            setTimeout(checkAndAddGift, 2000); // Slight delay to ensure the product is added first
        }
    });
});
  */
  
});